// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36JRf","wrapper-nopadding":"wrapper-nopadding__wfy6S","loading":"loading__3IdOn","error":"error__XZFoJ","table-loading":"table-loading__htn3Z","empty-val":"empty-val__3-QsJ","panelheader-tools":"panelheader-tools__1k1NU","propsPanels":"propsPanels__HIrew","new":"new__1HWSG","marginLm":"marginLm__1UlBR","marginRm":"marginRm__1noWa","fullWidth":"fullWidth__TOv9s","fullHeight":"fullHeight__i9lns","noData":"noData__Iz5ie","content":"content__2y2uX","propslist":"propslist__3Ohqa","action":"action__1Nnec"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AccountCenter/coms/InfoView/styles.scss
// module id = 2160
// module chunks = 1